import { Sublet, subletSchema } from "@boark/shared/types/sublet";
import { SubletCreate } from "@boark/shared/types/sublet-create";
import { SubletUpdate } from "@boark/shared/types/sublet-update";
import {
  SubletWithHoldingOrLeaseAndApartment,
  subletWithHoldingOrLeaseAndApartmentSchema,
} from "@boark/shared/types/sublet-with-holding-or-lease-and-apartment";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getSublets(): Promise<
  SubletWithHoldingOrLeaseAndApartment[]
> {
  return getRequest(
    `${API_BASE_URL}/sublet`,
    z.array(subletWithHoldingOrLeaseAndApartmentSchema),
  );
}

export async function getSublet(
  id: string,
): Promise<SubletWithHoldingOrLeaseAndApartment> {
  return await getRequest(
    `${API_BASE_URL}/sublet/${id}`,
    subletWithHoldingOrLeaseAndApartmentSchema,
  );
}

export async function createSublet(sublet: SubletCreate): Promise<Sublet> {
  return await postRequest(`${API_BASE_URL}/sublet`, sublet, subletSchema);
}

export async function updateSublet(
  id: string,
  sublet: SubletUpdate,
): Promise<Sublet> {
  return await putRequest(`${API_BASE_URL}/sublet/${id}`, sublet, subletSchema);
}

export async function deleteSublet(id: string): Promise<void> {
  return await deleteRequest(`${API_BASE_URL}/sublet/${id}`);
}
